import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getApiKey, getUser } from "../../helpers";

function StaffRoute({ component: Component, ...rest }) {
  const user = JSON.parse(getUser() || "null");

  return (
    <Route
      {...rest}
      render={(props) =>
        getApiKey() && user?.is_staff ? (
          <Component {...props} />
        ) : (
          <Redirect to={"/"} />
        )
      }
    />
  );
}

export default StaffRoute;
